import React from 'react';
import Navbar from '../../components/Navbars/AppNavbar.js';
import Footer from '../../components/Footers/Footer.js';
import FooterSM from '../../components/Footers/FooterSmall.js';
import SellerContainer from '../../components/Collector/index';
import { NextSeo, SocialProfileJsonLd } from 'next-seo';
import { useRouter } from 'next/router';
import { getUserName } from '../../services/common-query';
import Head from 'next/head';
import { firebaseFireStore } from '../../config/firebaseFirestore.js';
import { doc, getDoc, getDocs, collection } from 'firebase/firestore/lite';

function SellerPage(props) {
  const router = useRouter();
  const { collectorId } = props;

  return (
    <>
      <Head>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <link
          rel="canonical"
          href={`https://musicart.io/collector/${collectorId}`}
        />
      </Head>

      {props.collectorData && (
        <>
          <NextSeo
            title={`${
              props.collectorName ? props.collectorName + ' - ' : ''
            }Collector - MusicArt`}
            description={props.collectorData.bio ? props.collectorData.bio : ''}
            openGraph={{
              type: 'website',
              title: `${
                props.collectorName ? props.collectorName + ' - ' : ''
              }Collector - MusicArt`,
              description: props.collectorData.bio
                ? props.collectorData.bio
                : '-',
              images: [
                {
                  url:
                    props.collectorData && props.collectorData.photoUrl
                      ? `${props.collectorData.photoUrl}_250x250?alt=media`
                      : 'https://i.imgur.com/Q0kiEsg.jpg',
                },
              ],
              site_name: 'MusicArt',
            }}
            twitter={{
              cardType: 'summary_large_image',
            }}
          />
          <SocialProfileJsonLd
            type="Person"
            name={props.collectorName ? props.collectorName : ''}
            url={`https://musicart.io/collector/${collectorId}`}
            sameAs={[
              `${props?.collectorData?.facebook}`,
              `${props?.collectorData?.instagram}`,
              `${props?.collectorData?.medium}`,
              `${props?.collectorData?.twitter}`,
            ]}
          />
          <Head>
            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{
                __html: JSON.stringify({
                  '@context': 'http://schema.org',
                  '@type': 'Person',
                  name: props.collectorName ? props.collectorName : '',
                  image:
                    props.collectorData && props.collectorData.photoUrl
                      ? `${props.collectorData.photoUrl}_250x250?alt=media`
                      : 'https://i.imgur.com/Q0kiEsg.jpg',
                  url: `https://musicart.io/collector/${collectorId}`,
                  description: props?.collectorData?.bio
                    ? props.collectorData.bio
                    : '',
                  // sameAs: [],
                }),
              }}
            />
          </Head>
        </>
      )}

      <Navbar transparent />
      <SellerContainer
        collectorData={props.collectorData}
        collectorName={props.collectorName}
      />
      <Footer />
      <FooterSM />
    </>
  );
}

// export async function getStaticProps(context) {
//   const { collectorId } = context.params;
//   // const url = "https://" + context.req.headers.host + context.resolvedUrl;
//   let summary = await getDoc(
//     doc(firebaseFireStore, 'musicartSellers', collectorId),
//   );

//   let collectorName = await getUserName(collectorId);

//   let data = {
//     ...summary.data(),
//   };

//   return {
//     props: {
//       collectorData: JSON.parse(JSON.stringify(data)),
//       collectorId: collectorId,
//       collectorName: collectorName,
//     },
//   };
// }

// export async function getStaticPaths(cont, vvv) {
//   const res = await getDocs(collection(firebaseFireStore, 'musicartSellers'));
//   // Get the paths we want to pre-render based on posts

//   const paths = res.docs.map((single) => ({
//     params: { collectorId: single.id },
//   }));
//   // We'll pre-render only these paths at build time.
//   // { fallback: blocking } will server-render pages
//   // on-demand if the path doesn't exist.
//   return { paths, fallback: 'blocking' };
// }

export async function getServerSideProps(context) {
  const { collectorId } = context.params;
  // const url = "https://" + context.req.headers.host + context.resolvedUrl;
  let summary = await getDoc(
    doc(firebaseFireStore, 'musicartSellers', collectorId),
  );

  let collectorName = await getUserName(collectorId);

  let data = {
    ...summary.data(),
  };

  return {
    props: {
      collectorData: JSON.parse(JSON.stringify(data)),
      collectorId: collectorId,
      collectorName: collectorName,
    },
  };
}
export default SellerPage;
